import { IEmendaParlamentarPagedResponse } from "models/response/emenda-parlamentar-paged-response";

export interface EmendaParlamentarDetailsState {
  emendaDetails: IEmendaParlamentarPagedResponse | null;
  loading: boolean;
  error: string | null;
}

export const ACTION_TYPES = {
  setEmendaDetails: 'setEmendaDetails',
  setLoading: 'setLoading',
  setError: 'setError',
} as const;

type ActionType = keyof typeof ACTION_TYPES;

export interface EmendaParlamentarDetailsAction {
  type: ActionType;
  payload: any;
}

export const EmendaParlamentarDetailsReducer = (
  state: EmendaParlamentarDetailsState,
  action: EmendaParlamentarDetailsAction
): EmendaParlamentarDetailsState => {
  switch (action.type) {
    case ACTION_TYPES.setEmendaDetails:
      return { ...state, emendaDetails: action.payload, error: null };
    case ACTION_TYPES.setLoading:
      return { ...state, loading: action.payload };
    case ACTION_TYPES.setError:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};
